import { useEffect, useImperativeHandle, useMemo } from 'react'
import { arrayOf, shape, number, string, bool, func, object, node } from 'prop-types'
import { useHistory, useParams, generatePath, Redirect } from 'react-router-dom'
import { BaseTabs } from 'layout'
import { useRoutes } from './RoutesProvider'

TabsSincronizzateConRotta.propTypes = {
  tabs: arrayOf(shape({
    chiave: string.isRequired,
    titolo: node.isRequired,
    Contenuto: func.isRequired,
    disabled: bool,
  })).isRequired,
  indiceTabDefault: number,
  chiaveRottaBase: string.isRequired,
  disabilitaOttimizzazione_TabNonVisibili: bool,
  inputRef: object,
  onEnterTab: func,
  onLeaveTab: func,
  nomeParamTab: string,
  paramsRottaBase: object,
}

export default function TabsSincronizzateConRotta(props) {
  const {
    tabs,
    indiceTabDefault = 0,
    chiaveRottaBase,
    disabilitaOttimizzazione_TabNonVisibili,
    inputRef,
    onEnterTab,
    onLeaveTab,
    nomeParamTab = 'tab',
    paramsRottaBase,
    ...propsTabs
  } = props

  const { getPath } = useRoutes()

  const history = useHistory()

  // Ottieni dalla rotta la tab da mostrare
  const { [nomeParamTab]: tab } = useParams()
  const indiceTabVisibile = tabs.findIndex(({ chiave, disabled }) => chiave === tab && !disabled)

  useEffect(() => {
    onEnterTab?.(indiceTabVisibile)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indiceTabVisibile])

  // Accorgimento per migliori performance e più consistenza
  const tabsDefinitive = useMemo(
    () => tabs.map(({ titolo, Contenuto, disabled }, indice) => ({
      titolo,
      contenuto: disabilitaOttimizzazione_TabNonVisibili
        ? <Contenuto />
        // Eseguo la render function solo della tab visibile. Questo migliora le performance
        // e garantisce che tutto venga ricaricato correttamente al cambio della tab
        : (indiceTabVisibile === indice) && <Contenuto />,
      disabled,
    })),
    [tabs, indiceTabVisibile, disabilitaOttimizzazione_TabNonVisibili]
  )

  useImperativeHandle(inputRef, () => ({ onChangeTab }))

  // Se nella rotta non c'è una tab valida, redirigi su quella di default
  if (indiceTabVisibile === -1) {
    return <Redirect to={costruisciRottaTab(indiceTabDefault)} />
  }

  // Aggiorna la rotta quando l'utente cambia tab
  function onChangeTab(indiceNuovaTab) {
    onLeaveTab?.(indiceTabVisibile, indiceNuovaTab)
    history.push(costruisciRottaTab(indiceNuovaTab))
  }

  function costruisciRottaTab(indiceNuovaTab) {
    const chiaveNuovaTab = tabs[indiceNuovaTab].chiave
    return generatePath(getPath(chiaveRottaBase), { ...paramsRottaBase, [nomeParamTab]: chiaveNuovaTab })
  }

  return (
    <BaseTabs
      tabs={tabsDefinitive}
      indiceTabVisibile={indiceTabVisibile}
      onChangeTab={onChangeTab}
      {...propsTabs}
    />
  )
}